import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { Users } from 'lucide-react'
import { fadeInUp, viewportOnce } from '../../utils/animations'

const DIRECTOR_IMAGE = '/pages/dr-nadia-kharbat.png'

export default function LeadershipPageContent() {
  const { t } = useTranslation()

  return (
    <div className="space-y-12 sm:space-y-16">
      <motion.section
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        variants={fadeInUp}
        className="mx-auto max-w-3xl text-center"
      >
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
          <Users className="h-7 w-7 text-primary" aria-hidden />
        </div>
        <h2 className="text-2xl font-bold text-primary sm:text-3xl">{t('leadershipPage.teamTitle')}</h2>
        <p className="mt-4 text-lg leading-relaxed text-text/75">{t('leadershipPage.teamText')}</p>
      </motion.section>

      <motion.section
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        variants={fadeInUp}
        className="mx-auto max-w-5xl overflow-hidden rounded-3xl border border-border/60 bg-white shadow-xl shadow-primary/5"
      >
        <div className="grid lg:grid-cols-[minmax(280px,340px)_1fr]">
          <div className="relative aspect-[4/5] max-h-[480px] bg-background sm:max-h-[520px] lg:aspect-auto lg:max-h-none">
            <div className="absolute inset-y-0 start-0 z-10 w-1.5 bg-accent" aria-hidden />
            <img
              src={DIRECTOR_IMAGE}
              alt={t('leadershipPage.directorName')}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
          </div>

          <div className="flex flex-col justify-center border-t border-border/60 px-6 py-8 sm:px-10 sm:py-10 lg:border-t-0 lg:border-s lg:px-10 lg:py-10 xl:px-12">
            <h3 className="text-2xl font-bold text-primary sm:text-3xl">{t('leadershipPage.directorName')}</h3>
            <p className="mt-2 text-sm font-semibold uppercase tracking-wide text-accent">
              {t('leadershipPage.directorTitle')}
            </p>
            <div className="my-6 h-px w-12 bg-accent/40" aria-hidden />
            <div className="space-y-4 text-base leading-relaxed text-text/75 sm:text-[1.05rem]">
              <p>{t('leadershipPage.directorBio1')}</p>
              <p>{t('leadershipPage.directorBio2')}</p>
            </div>
          </div>
        </div>
      </motion.section>
    </div>
  )
}
